import { ConnectCandidateRow } from './CandidateRow/ConnectCandidateRow';
import { useState } from 'react';

import { ConnectCandidatesListProps, CurrentlyOpenModal } from '../types';
import { ATSConnectHiringRequestTestIds } from 'data-testids/ATS';
import auth from 'utils/auth';
import { Box, Link, Typography, useTheme } from '@mui/material';
import { CandidatesListContainer } from '../styles/hiringRequestStyles';

export const ConnectCandidatesList: React.FC<ConnectCandidatesListProps> = ({ results }) => {
  const [currentModalOpen, setCurrentModalOpen] = useState<CurrentlyOpenModal | null>(null);

  const theme = useTheme();

  const handleModalClose = () => setCurrentModalOpen(null);

  const handleModalOpen = ({ candidateId, modalType, roleId }: CurrentlyOpenModal) =>
    setCurrentModalOpen({ candidateId, modalType, roleId });

  if (results?.length === 0) {
    const isSchoolUser = auth.isSchoolUser();
    const candidatesListLink = auth.isSchoolAdmin() ? '/school/candidates' : '/district/candidates';

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography sx={{ paddingTop: theme.spacing(2) }}>
          You have no hiring requests at the moment
        </Typography>
        {!isSchoolUser && (
          <Link
            data-testid={ATSConnectHiringRequestTestIds.VIEW_ALL_CANDIDATES_BUTTON}
            href={candidatesListLink}
            sx={{ paddingTop: theme.spacing(1) }}
          >
            View all candidates
          </Link>
        )}
      </Box>
    );
  }

  return (
    <CandidatesListContainer>
      {results.map((result) => (
        <ConnectCandidateRow
          currentModalOpen={currentModalOpen}
          currentRow={result}
          isModalOpen={
            currentModalOpen?.candidateId === result.candidate.id &&
            currentModalOpen?.roleId === result.role.id
          }
          key={result.id}
          onCloseModal={handleModalClose}
          onOpenModal={handleModalOpen}
        />
      ))}
    </CandidatesListContainer>
  );
};
